import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import AllTables from "../../pages/InventoryManagement/Tables/AllTables";

const AllTablesRoutes = {
  path: "/inventory",
  element: <Navbar />,
  children: [
    {
      path: "alltables",
      element: <AllTables />,
    },
  ],
};

export default AllTablesRoutes;
